import { defineMessages } from "@/i18n";
import en from "./en";

export const previewCardFrameMessages = defineMessages(
  "frames-preview-card",
  en,
);
